import Vue from "vue";
import _ from "lodash";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "./plugins/element.js";
import "./theme/index.css";

Vue.config.productionTip = false;
Vue.prototype._ = _;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
